
export class Labels {

    constructor() { }

    Weeks: KayPair[];
    Days: KayPair[];
    OrdinalNumbers: KayPair[];
    Outcome: KayPair[];
    AccountType: KayPair[];
    Customer: KayPair[];
    BarComponent: KayPair[];
    VisitDistributionTable: KayPair[];
    VisitFrequencyPieChart: KayPair[];
    CustomerStatusAdherenceBarChart: KayPair[];
    CustomersVisitedInAlarmBarChart: KayPair[];
    LinkTitle: KayPair[];
    CentralToolBar: KayPair[];
    LegendaPopup: KayPair[];
    FilterOptions: KayPair[];
    SalesRapPanel: KayPair[];
}

export class KayPair {
    Key: any;
    Value: string;
}



// WEBPACK FOOTER //
// ./src/app/model/language.model.class.ts